export default __webpack_public_path__ + "3c8029ddfe1fc0bae1f20a64c14283cd.png";